import { Item } from '../../core';
import { ViewCategory } from '../model/view-category.model';

export function filterByKeyword(
    keyword: string | null,
    categories: ViewCategory[],
    items: Item[],
): Item[] {
    if (keyword == null || keyword.trim().length === 0) {
        return [...items];
    }

    return items.filter((e) => {
        const cat = categories.find((c) => c.categoryId === e.categoryId);
        const kw = keyword.toLowerCase();
        return (
            cat?.label?.toLowerCase().includes(kw) ||
            e.name?.toLowerCase().includes(kw) ||
            e.title?.toLowerCase().includes(kw) ||
            e.message?.toLowerCase().includes(kw)
        );
    });
}
